// El backend serializa OccurredAt (UTC) SIN sufijo 'Z' -> new Date() lo tomaria como hora
// local del navegador. Forzamos UTC y mostramos en hora de Chile (America/Santiago).
export const formatChileDateTime = (value) => {
  if (!value) return '';
  const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value);
  const d = new Date(hasTz ? value : `${value}Z`);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('es-CL', {
    timeZone: 'America/Santiago',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Solo fecha (sin hora), en hora de Chile. Fuerza UTC si el valor viene sin 'Z'.
export const formatChileDate = (value) => {
  if (!value) return '';
  const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value);
  const d = new Date(hasTz ? value : `${value}Z`);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('es-CL', {
    timeZone: 'America/Santiago',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

// Igual que formatChileDateTime pero desde un instante en ms (para fechas ya normalizadas).
export const formatChileMs = (ms) => {
  if (!ms) return '';
  const d = new Date(ms);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('es-CL', {
    timeZone: 'America/Santiago',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Instante (ms UTC) de un OccurredAt sin 'Z', para comparar el ultimo contacto por canal.
export const toUtcMs = (value) => {
  if (!value) return 0;
  const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value);
  const d = new Date(hasTz ? value : `${value}Z`);
  return Number.isNaN(d.getTime()) ? 0 : d.getTime();
};
